import axios from "axios";

export const ADD_EDIT_TEMP_INSPECTION = '/inspections/addEditTempShuma';
export const GET_TEMP_INSPECTIONS_LIST = '/inspections/getTempShumaList';

interface AddEditTempInspectionRequestBody {
  priceQuoteID: number
  tempShumaID: number
  shumaReasonID: string
  shumaTypeID: number | null
  propertyTypeID: number | null
  bankID: number | null
  loanTypeID: number | null
  loanText: string
  otherPropertyTypeID: number | null
  bankBranchNumber: string
  bankBranchName: string
  bankClerkFullName: string
  bankEmail: string
  bankRequestID: string
  bankBuildType: string
  dueDate: string | null
  city: number | null
  street: number | null
  houseNumber: string
  apartmentNumber: string
  gush: string
  helka: string
  ttHelka: string
  notes: string
  responsibleUser: number | null
  loanSubTypeID: number | null
  shumaMazminIdentityID: number | null
  landLotNum: string
  landLotNumAccordingTaba: string
  purchaseCompensation: string
}

export const addEditTempInspection = async ({
                                         priceQuoteID,
                                         tempShumaID,
                                         shumaReasonID,
                                         shumaTypeID,
                                         propertyTypeID,
                                         bankID,
                                         loanTypeID,
                                         loanText,
                                         otherPropertyTypeID,
                                         bankBranchNumber,
                                         bankBranchName,
                                         bankClerkFullName,
                                         bankEmail,
                                         bankRequestID,
                                         bankBuildType,
                                         dueDate,
                                         city,
                                         street,
                                         houseNumber,
                                         apartmentNumber,
                                         gush,
                                         helka,
                                         ttHelka,
                                         notes,
                                         responsibleUser,
                                         loanSubTypeID,
                                         shumaMazminIdentityID,
                                         landLotNum,
                                         landLotNumAccordingTaba,
                                         purchaseCompensation
                                       }: AddEditTempInspectionRequestBody) => {
  const data = {
    priceQuoteID: priceQuoteID ? parseInt(priceQuoteID.toString(), 10) : null,
    tempShumaID: tempShumaID ? parseInt(tempShumaID.toString(), 10) : null,
    shumaReasonID: shumaReasonID ? parseInt(shumaReasonID.toString(), 10) : null,
    shumaTypeID:  shumaTypeID ? parseInt(shumaTypeID.toString(), 10) : null,
    propertyTypeID: propertyTypeID ? parseInt(propertyTypeID.toString(), 10) : null,
    bankID: bankID ? parseInt(bankID.toString(), 10) : null,
    loanTypeID: loanTypeID ? parseInt(loanTypeID.toString(), 10) : null,
    loanText,
    otherPropertyTypeID: otherPropertyTypeID ? parseInt(otherPropertyTypeID.toString(), 10) : null,
    bankBranchNumber: bankBranchNumber ? parseInt(bankBranchNumber, 10) : null,
    bankBranchName,
    bankClerkFullName,
    bankEmail,
    bankRequestID,
    bankBuildType,
    dueDate,
    city: city ? parseInt(city.toString(), 10) : null,
    street: street? parseInt(street.toString(), 10) : null,
    houseNumber,
    apartmentNumber,
    gush,
    helka,
    ttHelka,
    notes,
    responsibleUser: responsibleUser ? parseInt(responsibleUser.toString(), 10) : null,
    loanSubTypeID: loanSubTypeID ? parseInt(loanSubTypeID.toString(), 10) : null,
    shumaMazminIdentityID: shumaMazminIdentityID ? parseInt(shumaMazminIdentityID.toString(), 10) : null,
    landLotNum,
    landLotNumAccordingTaba,
    purchaseCompensation
  };
  try {
    const response = await axios.post(ADD_EDIT_TEMP_INSPECTION, data);
    const {errorCode, body} = response.data;

    if (errorCode < 0) {
      throw new Error("Error creating/editing temp inspection");
    }

    return body?.tempShumaID;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTempInspectionsList = async (priceQuoteID: number) => {
  const response = await axios.get(GET_TEMP_INSPECTIONS_LIST, {
    params: {
      priceQuoteID
    },
  });
  const {errorCode, body} = response.data;
  if (errorCode < 0) {
    throw new Error();
  }

  return body?.list ?? [];
};